// 9fbef606107a605d69c0edbcd8029e5d
import { connect } from 'react-redux';
import CheckoutSelector from '../../../../features/CnC/Checkout/container/Checkout.selector';
import SpcSelector from '../../../../features/CnC/SinglePageCheckout/container/SinglePageCheckout.selector';
import { getIsPLCCModalOpen } from '../../ApplyNowPLCCModal/container/ApplyNowModal.selectors';
import LoaderView from '../views';
import { getQuickViewLoader } from './Loader.selector';

const mapStateToProps = (state) => {
  const { PageLoader } = state;
  return {
    loaderState: PageLoader && PageLoader.loaderState,
    miniBagLoaderState: PageLoader && PageLoader.miniBagLoaderState,
    addedToBagLoaderState: PageLoader && PageLoader.addedToBagLoaderState,
    addedToBagGhostLoaderState: PageLoader && PageLoader.addedToBagGhostLoaderState,
    spc: SpcSelector.checkIsSinglePageCheckout(state),
    quickViewLoader: getQuickViewLoader(state),
    applePayInProgress: CheckoutSelector.isApplePaymentInProgress(state),
    isPLCCModalOpen: getIsPLCCModalOpen(state),
    afterPayPaymentProgress: CheckoutSelector.getIsAfterPayPaymentProgress(state),
    isPaypalPaymentProgress: CheckoutSelector.getIsPaypalPaymentProgress(state),
  };
};

export default connect(mapStateToProps, {})(LoaderView);
